import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";

var _createReducer;

import { createReducer } from 'redux-act';
import { signout, softSignout } from "../../actions";
import { createTUCustomer, setTUAuthentication } from "../actions";
import { getAntiFraudDecision } from "../actions/utils";
export default createReducer((_createReducer = {}, _defineProperty(_createReducer, signout.success, function () {
  return null;
}), _defineProperty(_createReducer, softSignout.success, function () {
  return null;
}), _defineProperty(_createReducer, createTUCustomer.success, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    antiFraudDecision: null
  });
}), _defineProperty(_createReducer, createTUCustomer.fail, function (state, _payload, _ref) {
  var resp = _ref.resp;
  return _objectSpread(_objectSpread({}, state), {}, {
    antiFraudDecision: getAntiFraudDecision(resp)
  });
}), _defineProperty(_createReducer, setTUAuthentication.success, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    antiFraudDecision: null
  });
}), _defineProperty(_createReducer, setTUAuthentication.fail, function (state, _payload, _ref2) {
  var resp = _ref2.resp;
  return _objectSpread(_objectSpread({}, state), {}, {
    antiFraudDecision: getAntiFraudDecision(resp)
  });
}), _createReducer), {});